import React from "react";
import { Popup, Header, Icon, Label } from "semantic-ui-react";
import { useSafePolling } from "hooks/useSafePolling";
import { ReactComponent as HeadsetIcon } from "assets/icons/svg/headset.svg";
import { useInView } from "react-intersection-observer";

const QueueHelpFolders = ({ queuedFolderHelps, getWaitingFolderHelp }) => {
	// Observer
	const { ref, inView } = useInView({
		threshold: 0, // dès qu’un pixel est visible
		triggerOnce: false,
	});

	// Poll uniquement si visible
	useSafePolling(getWaitingFolderHelp, {
		delay: 10000,
		timeoutThreshold: 10000,
		enabled: inView,
	});

	return (
		<div ref={ref}>
			<Popup
				position="bottom center"
				content={
					<Header as="h4">
						<Icon name="inbox" />
						<Header.Content>
							{queuedFolderHelps} dossier{queuedFolderHelps > 1 ? "s" : ""} en attente au télésecrétariat.
						</Header.Content>
					</Header>
				}
				trigger={
					<Label
						style={{
							color: "white",
							backgroundColor: "#2a7b6f",
							marginLeft: "5px",
							display: "flex",
							gap: "5px",
							alignItems: "center",
							padding: "4px 5px",
						}}
					>
						<HeadsetIcon style={{ height: "18px" }} />
						{queuedFolderHelps}
					</Label>
				}
			/>
		</div>
	);
};

export default QueueHelpFolders;
